import { render, staticRenderFns } from "./VEmployerEmployeesTemplateEmployment.vue?vue&type=template&id=19436388&lang=pug"
import script from "./VEmployerEmployeesTemplateEmployment.vue?vue&type=script&lang=ts"
export * from "./VEmployerEmployeesTemplateEmployment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports